import {API_STATUS, VENDOR} from '@/constants/constants';
import _get from 'lodash/get';

function isFailResponse(response) {
  return _get(response, 'data.status') === API_STATUS.FAIL;
}

function addLoginUserInfoToPayload(payload, store) {
  return Object.assign({}, payload, {
    userId: store.state.loginUser.userId,
    userEmail: store.state.loginUser.userEmail,
    userName: store.state.loginUser.userNm,
    siteId: store.state.loginUser.siteCd,
    cmpnId: store.state.loginUser.curCmpnId,
  });
}

export {
  isFailResponse,
  addLoginUserInfoToPayload
};



// WEBPACK FOOTER //
// ./src/components/pages/mis-operation-status/common/functionUtils.js